import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import { resolvePostAuthRedirectPath } from 'src/routes/auth/auth.redirect';

/**
 * Authenticated users who land on /login (e.g. after Auth0 callback or a
 * signed-out deep-link race) should honor returnTo instead of always going home.
 */
const AuthenticatedLoginRedirect = () => {
    const [searchParams] = useSearchParams();
    const { appState } = useAuth0();

    return (
        <Navigate
            to={resolvePostAuthRedirectPath({ searchParams, appState })}
            replace
        />
    );
};

export default AuthenticatedLoginRedirect;
